import { createReducer } from 'redux-act';

import {
  WEB_PAGES_FETCH, WEB_PAGES_FETCH_DATA_SUCCESS, WEB_PAGES_FETCH_DATA_FAIL,
  WEB_PAGES_DELETE_INIT, WEB_PAGES_DELETE_SUCCESS, WEB_PAGES_DELETE_FAIL,
  WEB_PAGES_CREATE_INIT, WEB_PAGES_CREATE_SUCCESS, WEB_PAGES_CREATE_FAIL,
  WEB_PAGES_MODIFY_INIT, WEB_PAGES_MODIFY_SUCCESS, WEB_PAGES_MODIFY_FAIL,
  WEB_PAGES_CLEAN_UP, WEB_PAGES_CLEAR_DATA_LOGOUT,
} from 'state/actions/webPages';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webPagesReducer = createReducer(
  {
    [WEB_PAGES_FETCH]: (state) => ({ ...state, loading: true, error: null }),
    [WEB_PAGES_FETCH_DATA_SUCCESS]: (state, payload) => ({ ...state, list: payload.list || [], loading: false }),
    [WEB_PAGES_FETCH_DATA_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [WEB_PAGES_CREATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [WEB_PAGES_CREATE_SUCCESS]: (state, payload) => ({ ...state, list: [...state.list, payload.page], loading: false, success: true }),
    [WEB_PAGES_CREATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [WEB_PAGES_MODIFY_INIT]: (state) => ({ ...state, loading: true, updated: false }),
    [WEB_PAGES_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) => item._id === payload.id ? payload.page : item),
      loading: false, updated: true,
    }),
    [WEB_PAGES_MODIFY_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, updated: false }),
    [WEB_PAGES_DELETE_INIT]: (state) => ({ ...state, loading: true, deleted: false }),
    [WEB_PAGES_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false, deleted: true,
    }),
    [WEB_PAGES_DELETE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, deleted: false }),
    [WEB_PAGES_CLEAN_UP]: (state) => ({ ...state, loading: false, error: null, success: false, deleted: false, updated: false }),
    [WEB_PAGES_CLEAR_DATA_LOGOUT]: () => ({ ...initialState }),
  },
  initialState
);
